import { observable, action } from "mobx";
import { BaseSportsHamburgerBlockData } from "../../../data";
import { BranchInfoModel, CmsLinkModel } from "../../../models";

export type LiveSportsHamburgerDataComposition = {
    branchesCache: BranchesCache,
    cmsLinks: any[],
    liveBettingPanelID: string
};

export class LiveSportsHamburgerBlockData extends BaseSportsHamburgerBlockData {
    branchesCache!: BranchesCache;
    cmsLinks!: CmsLinkModel[];
    @observable sportsData: BranchInfoModel[];
    panels!: any[];
    openLiveBettingHandler : Function;
    adjustPathFunc!: Function;
    navigateToCmsLinkHandler!: Function;
    pageNavigationConfig: any;
    mapToBranchInfoModelRef: (value : BranchInfoType) => BranchInfoModel;
    mapToCmsLinkModelRef!: (value : any) => CmsLinkModel;
    liveBettingPanelID: string;
    closeMenuHandler: Function;

    constructor(provider : LiveSportsHamburgerDataComposition, navHandler : any) {
        super(provider, navHandler);

        this.openLiveBettingHandler = navHandler.OpenMobileLiveBetting;
        this.mapToBranchInfoModelRef = this
            .mapToBranchInfoModel
            .bind(this);
        this.pageNavigationConfig = navHandler.Navigation.pageNavigationConfig;
        this.liveBettingPanelID = provider.liveBettingPanelID;
        this.sportsData = this
            .branchesCache
            .BranchesOrdered
            .filter(this.filterLiveEvents)
            .map(this.mapToBranchInfoModelRef);

        // Attach events
        this
            .branchesCache
            .addListener(this, this.updateSportsData);
        this.closeMenuHandler = navHandler.CloseLeftNav;
    }

    get liveBettingPanelPath() {
        let { CurrentLanguageUrlCode,
            SportsNavigationCode } = this.pageNavigationConfig;

        let path : string = "";
        if (CurrentLanguageUrlCode)
        {
            path += "/" + CurrentLanguageUrlCode;
        }

        if (SportsNavigationCode) {
            path += "/" + SportsNavigationCode;
        }

        path += "/" + this.liveBettingPanelID;

        return path;
    }

    /* istanbul ignore next */
    @action.bound updateSportsData() {
        this.sportsData = this
            .branchesCache
            .BranchesOrdered
            .filter(this.filterLiveEvents)
            .map(this.mapToBranchInfoModelRef);
    }

    filterLiveEvents(branchInfo) {
        return branchInfo.hasLiveEvents;
    }

    mapToBranchInfoModel(branchInfo) {
        return new BranchInfoModel({
            id: branchInfo.ID,
            name: branchInfo.Name,
            href: `${this.liveBettingPanelPath}#0#0#${branchInfo.ID}`,
            hasLiveEvents: branchInfo.hasLiveEvents,
            totalLiveCount: branchInfo.TotalLiveCount,
            handler: this
                .openLiveBetting
                .bind(this, this.liveBettingPanelID, branchInfo.ID)
        });
    }

    openLiveBetting(panelID, branchID, event) {
        this.closeMenuHandler();
        this.openLiveBettingHandler(event, panelID, branchID);
    }
}